
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../_services/auth_service';
import { RedirectService } from '../_services/redirect_service';
import {HttpResponse} from "@angular/common/http";
import {of, tap} from "rxjs";
import {catchError, map} from "rxjs/operators";

export const ForcePasswordChangeGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const redirect = inject(RedirectService);

    return authService.getUserData().pipe(
        tap((response: HttpResponse<any>) => {
            // Verifica il valore di cambio_pwd_ck
            if (response.body?.cambio_psw_ck) {
                router.navigate(['/forzacambiopassword']); // Reindirizza se deve cambiare la password
            }
        }),
        map((response: HttpResponse<any>) => !response.body?.cambio_psw_ck), // Permetti la navigazione se non è true
        catchError((error) => {
            // Questo guard e' canActivateChild e gira PRIMA dei canActivate di
            // ruolo: e' quello che intercetta il 401 sul deep-link. Salva la
            // destinazione (consumata poi in dashboard) e redirige a /login.
            redirect.save(state.url);
            return of(router.createUrlTree(['/login']));
        })
    );

};
